import React from 'react'
import { Footer } from './style'
import {Toast} from 'antd-mobile'
// import bwmodel from '@/config/bwmodel'
import bridge from '@/config/JSbridge'

const PageFooter = ({userInfo}) => {
 
  const shareUrl = '#/active_50/share-pull-regist/'

  //  function handleScroll(e) {
  //     // let tips = document.getElementById('tips');
  //     let footer = document.getElementById('footer');

   
  //     if(footer) {
  //       if(window.scrollY >=200) {
  //         footer.classList.add('footer-freeclass-block');
  //       }else {
  //         footer.classList.remove('footer-freeclass-block');
  //       }
  //     }
     
  //   }
  //   useEffect(()=>{
  //     window.addEventListener('scroll', handleScroll);
  //     return   window.addEventListener('scroll', null);
  //   }, [])

    const sendWebTracking = (id) => {
      const params = {
        event: 'webTracking',
        params: {
          actionId: id,  // 事件id
          extraInfo: {   // 非必需
            type:  'button',   // 事件类型
            url: window.location.href
          } //额外的参数
        }
      }
      bridge.callHandler('nativeEvent', params)
    }

  
    return (
      <Footer id='footer'>
        <div className={'desc'}>  </div>

        {/* <button className={'button'} style={{'minWidth':'40px'}} alt="" onClick={() => {
            // console.log( bwmodel.compareVersion('4.16.9'));

            if (userInfo.code) {
           
              bridge.callHandler('nativeEvent', {
                event: 'showShareImageWithQR',
                params: {
                  backImageUrl: 'https://filetest.wogoo.com/app/article/20220610/4a4205f0ea1243db9ce67d5cf6903203.png',
                  QRUrl: 'https://www.baidu.com'
           
                }
              })
            } else {
                Toast.info('请先登录APP')
              }
           
          }} >
            测试专用
            </button> */}

        {/* <button className={'button'} style={{'minWidth':'40px'}} alt="" onClick={() => {
            // console.log( bwmodel.compareVersion('4.16.9'));

            if (userInfo.code) {
           
              bridge.callHandler('nativeEvent', {
                event: 'showShareImageWithQR',
                params: {
                  backImageUrl: 'https://filetest.wogoo.com/www2/test/59.png',
                  QRUrl: process.env.REACT_APP_DEMAND_URL + shareUrl + userInfo.code
                 
                }
              })
            } else {
                Toast.info('请先登录APP')
              }
           
          }} >
            客户端
            </button> */}

        <div className={'buttons'}>
     
  
          <img className={'button'} src={require('@/img/activity22/download.png')} alt="" onClick={() => {
            // console.log( bwmodel.compareVersion('4.16.9'));
            sendWebTracking('combination_download_button')
            if (userInfo.code) {
              bridge.callHandler('nativeEvent', {
                event: 'nativeShare',
                params: {
                  action: 'shareImage',
                  // type: bwmodel.compareVersion('4.16.9')? 'springFestivalActivity_v417':'springFestivalActivity',
                  type: 'springFestivalActivity',
                  data: {
                    link: process.env.REACT_APP_DEMAND_URL + shareUrl + userInfo.code
                  }
                }
              })
            } else {
              Toast.info('请先登录APP')
            }
          }} />
          <img className={'button'} src={require('@/img/activity22/vfriends.png')} alt="" onClick={() => {
            sendWebTracking('combination_vfriends_button')
            if (userInfo.code) {
              bridge.callHandler('nativeEvent', {
                event: 'nativeShare',
                params: {
                  action: 'wechat_friend',
                  type: 'springFestivalActivity',
                  data: {
                    title:  `${userInfo.user.nickname}邀请您来参与组合炒股大赛，赢取万元大奖！`,
                    link: process.env.REACT_APP_DEMAND_URL + shareUrl + userInfo.code,
                    icon: 'https://file.wogoo.com/app/logo/logo6.png'
                  }
                }
              },(res)=> {
                const str = JSON.stringify(res);
                Toast.info(str)
                // alert(str);
              })
            } else {
              Toast.info('请先登录APP')
            }
          }}/>
          {/*  9e93c20553d24a2e9e99c6a6e6fc1bdc */}
          <img className={'button'} src={require('@/img/activity22/vfriend.png')}  alt="" onClick={() => {
            sendWebTracking('combination_vfriend_button')
            if (userInfo.code) {
              bridge.callHandler('nativeEvent', {
                event: 'nativeShare',
                params: {
                  action: 'wechat',
                  type: 'springFestivalActivity',
                  data: {
                    title:  `${userInfo.user.nickname}邀请您来参与组合炒股大赛，赢取万元大奖！！`,
                    subTitle: '华为Mate60Pro、小米14、300元京东卡…..13次赢取大奖机会！',
                    link: process.env.REACT_APP_DEMAND_URL + shareUrl + userInfo.code,
                    icon: 'https://file.wogoo.com/app/logo/logo6.png'
                  }
                }
              },(res)=> {
                
                console.log(res);
                const str = JSON.stringify(res);
                Toast.info(str)
              })
            } else {
              Toast.info('请先登录APP')
            }
          }} />
      
        </div>
      </Footer> 
    )
}


export default PageFooter;


// WEBPACK FOOTER //
// ./src/views/activity_50/Footer/index.js